/* eslint no-prototype-builtins: 0 */
/* eslint no-restricted-syntax: 0 */
/* eslint no-unused-vars: 0 */
/* eslint-env browser */
import React from 'react';
import ReactDOM from 'react-dom';
import AlphaBoxComponent from '../components/alphabox/AlphaBoxComponent';

const defaultOptions = {
  config: {
    title: '',
    url: '',
    description: '',
    container: '.au_alphabox',
    tracking: '/virtual/alphabox/',
    links: [
      { title: 'Link 1', url: 'http://www.au.dk' },
      { title: 'Link 2', url: 'http://www.au.dk' },
    ],
  },
  search: {
    minLength: 1,
    placeHolder: '',
  },
  background: {
    color: '#003e5c',
    linkColor: '#379fcb',
  },
  data: {
    mode: 'json',
    itemsOnly: false,
  },
};

class AUAlphabox {
  constructor(boxes) {
    this.boxes = boxes;
  }

  static mergeOptions(_box) {
    const box = _box;
    if (!box.hasOwnProperty('config')) {
      box.config = {};
    }

    for (const conf in defaultOptions.config) {
      if (!box.config.hasOwnProperty(conf)) {
        box.config[conf] = defaultOptions.config[conf];
      }
    }

    if (!box.hasOwnProperty('background')) {
      box.background = {};
    }

    for (const bg in defaultOptions.background) {
      if (!box.background.hasOwnProperty(bg)) {
        box.background[bg] = defaultOptions.background[bg];
      }
    }

    if (!box.hasOwnProperty('search')) {
      box.search = {};
    }

    for (const sch in defaultOptions.search) {
      if (!box.search.hasOwnProperty(sch)) {
        box.search[sch] = defaultOptions.search[sch];
      }
    }

    if (!box.hasOwnProperty('data')) {
      box.data = {};
    }

    for (const data in defaultOptions.data) {
      if (!box.data.hasOwnProperty(data)) {
        box.data[data] = defaultOptions.data[data];
      }
    }
  }

  init() {
    for (let i = 0; i < this.boxes.length; i += 1) {
      const box = this.boxes[i];
      if (!box.loaded) {
        box.id = i;
        AUAlphabox.mergeOptions(box);
        const mountNode = document.querySelector(box.config.container);
        const visible = mountNode && getComputedStyle(mountNode).visibility !== 'hidden';
        if (visible) {
          ReactDOM.render(
            <AlphaBoxComponent box={box} />, mountNode,
          );
          box.loaded = true;
        }
      }
    }
  }
}

window.AUAlphabox = AUAlphabox;
